var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wait_container",style:({height: _vm.clientHeight+'px'})},[_c('div',{staticClass:"wait_text"},[_vm._v("敬请期待~")])])}
var staticRenderFns = []

export { render, staticRenderFns }